export enum QuotationBlockCategoryCodeEnum {
    accomodation = 'accomodation',
    transportation = 'transportation',
    price = 'price',
    misc = 'misc',
    activity = 'activity',
    goodToKnow = 'goodToKnow',
    miscellaneous = 'miscellaneous',
    car = 'car',
    place = 'place',
    meal = 'meal',
    strongPoint = 'strongPoint',
    salesPolicy = 'salesPolicy',
    notIncludedPrice = 'notIncludedPrice',
    includedPrice = 'includedPrice',
    insurance = 'insurance',
}
